const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Semantic Modal component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('suModal', [function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      type: '@',
      show: '=',
      large: '@?',
      nodim: '=?'
    },
    transclude: true,
    template: '<div class="ui modal" ng-class="{active: show, small: !large, large: large}" ng-transclude></div>',
    link: function (scope, element, attrs, ngModel) {
      var currentlyShowing = false;

      var dimmerEl = document.createElement('div');

      var hideOverlay = function() {
        currentlyShowing = false;
        dimmerEl.setAttribute('class', 'ui dimmer transition active animating fade out');
        setTimeout(function() {
          if (dimmerEl.parentNode) {
            dimmerEl.parentNode.removeChild(dimmerEl);
          }
          dimmerEl.setAttribute('class', 'ui dimmer transition active');
        }, 300);
      };

      dimmerEl.addEventListener('click', function(){
        hideOverlay();
        scope.show = false;
        scope.$apply();
      }, false);

      scope.$watch('show', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          dimmerEl.setAttribute('class', 'ui dimmer transition active animating fade in');
          if (!scope.nodim) {
            document.querySelector('.ngview').appendChild(dimmerEl);
          };
          currentlyShowing = true;
          setTimeout(function() {
            dimmerEl.setAttribute('class', 'ui dimmer transition active');
          }, 300);
        }
        if (oldVal && !newVal && currentlyShowing) {
          hideOverlay();
        }
      });
    }
  };
}]);
